import {
  Loader,
  NavigateTo,
  RedirectState,
  useCurrentCompanyId,
  useCurrentUserScopeForCurrentCompany,
  getDefaultSredPath,
} from '@neo.tax/shared';
import { useSredContext } from '@neo.tax/sred/context';
import { isSredPathAvailable, SredPath } from '@neo.tax/sred/utils';

export const SredPathLoader = ({
  path,
  children,
  useRedirect = (): RedirectState => ({ isLoading: false }),
}: {
  path: SredPath;
  children: React.ReactNode;
  useRedirect: () => RedirectState;
}): React.ReactElement => {
  const companyId = useCurrentCompanyId();
  const { fiscalYearId } = useSredContext();
  const { limitAccessToFinancialData } = useCurrentUserScopeForCurrentCompany();

  if (
    !isSredPathAvailable({
      isNonFinancialUser: limitAccessToFinancialData,
      path,
    })
  ) {
    return <NavigateTo to={getDefaultSredPath({ companyId, fiscalYearId })} />;
  }

  return <Loader useRedirect={useRedirect}>{children}</Loader>;
};
